import { Combobox, ComboboxOption, ComboboxOptions } from '@headlessui/react';
import Input from '@ui/Input';
import { cx } from 'class-variance-authority';
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from 'use-places-autocomplete';

function PlacesAutocomplete({
  setSelected,
  requireLatLng,
  className,
  hideSearchIcon,
  MXAuto = true,
}: {
  setSelected: ({
    lat,
    lng,
    address,
  }: {
    lat?: number;
    lng?: number;
    address: string;
  }) => void;
  requireLatLng?: boolean;
  className?: string;
  hideSearchIcon?: boolean;
  MXAuto?: boolean;
}) {
  const {
    ready,
    value,
    setValue,
    suggestions: { status, data },
    clearSuggestions,
  } = usePlacesAutocomplete({
    requestOptions: {
      types: ['(cities)'],
    },
  });

  const handleSelect = async (address: any) => {
    setValue(address, false);
    clearSuggestions();

    if (requireLatLng) {
      const results = await getGeocode({ address });
      const { lat, lng } = getLatLng(results[0]);
      setSelected({ lat, lng, address });
    } else {
      setSelected({ address });
    }
  };

  return (
    <Combobox
      as="div"
      className={`${MXAuto && 'mx-auto '} w-full max-w-[70rem]`}
      disabled={!ready}
    >
      <div className="relative">
        <Input
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="Search by city"
          type={'search'}
          className={className}
          searchIconRight
          hideSearchIcon={hideSearchIcon}
          iconClassName="!text-zinc-600 !h-6 !w-6"
          searchButtonClassName="!bg-transparent"
        />

        {status === 'OK' && (
          <ComboboxOptions
            static
            className="absolute top-[4.4rem] z-10 mt-2 w-full overflow-y-auto overflow-x-hidden rounded-[.8rem] bg-brand-white py-1 pb-[8rem] text-[1.4rem] shadow-sm  sm:max-h-[75vh] sm:pb-0 sm:ring-1 sm:ring-brand-black sm:ring-opacity-5"
          >
            {data.map(({ place_id, description }) => (
              <ComboboxOption
                className={({ active }) =>
                  cx(
                    'relative flex cursor-pointer select-none items-center py-3 pl-[2rem] pr-4',
                    active ? 'bg-brand-secondary-light' : ''
                  )
                }
                key={place_id}
                value={description}
                onClick={() => {
                  handleSelect(description);
                }}
              >
                {description}
              </ComboboxOption>
            ))}
          </ComboboxOptions>
        )}
      </div>
    </Combobox>
  );
}

export default PlacesAutocomplete;
